import React from "react";
import searchIcon from "../../assets/images/searchicon.svg";
import Inputlayer from "../../components/FormComponent/Input";
import TechnicianPatientCard from "./TechnicianPatientCard";

const TechnicianCardsDisplay = ({ patientSchema, data, handleChange }) => {
  return (
    <div class="TechnicianCardsDisplay">
      <span class="PatientsTitle">{`Patients (${data.patientData.length})`}</span>
      {patientSchema.feilds.map((field, key) => {
        if (field.element === "input") {
          return (
            <div class="row pt-3">
              <div class="col-10 pr-0">
                <Inputlayer
                  key={key}
                  // {...this.props}
                  // {...this.state}
                  feildData={field}
                  onInputChanges={handleChange}
                />
              </div>
              <div class="biller-search-icon">
                <img
                  src={searchIcon}
                  alt=""
                  className="biller-search-icon-img"
                />
              </div>
            </div>
          );
        }
      })}
      <div className="ml-1 PatientCardsDisplayScroll">
        <TechnicianPatientCard data={data} />
        <TechnicianPatientCard data={data} />
        <TechnicianPatientCard data={data} />
        <TechnicianPatientCard data={data} />
        <TechnicianPatientCard data={data} />
        <TechnicianPatientCard data={data} />
      </div>
    </div>
  );
};
export default TechnicianCardsDisplay;
